import type { ReactNode } from 'react';

type Props = {
  eyebrow: string;
  title: string;
  description?: string;
  extra?: ReactNode;
};

export default function SectionHeading({ eyebrow, title, description, extra }: Props) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
      <div>
        <p className="flex items-center gap-2 text-xs tracking-[0.24em] text-primary-600 uppercase mb-3">
          <span className="w-6 h-px bg-primary-500" aria-hidden="true"></span>
          {eyebrow}
        </p>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">{title}</h2>
        {description && (
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-7 max-w-2xl">{description}</p>
        )}
      </div>
      {extra}
    </div>
  );
}